import { createTheme } from '@mui/material/styles';

// アプリ全体の MUI テーマ定義
// Select のドロップダウン (Menu/Popover) を開いた際、MUI が body に
// overflow hidden + padding-right (スクロールバー幅) を付与して
// 画面右端に余白 (白い帯) が見える問題を防ぐため、
// Menu / Popover のスクロールロックを全体で無効化する。
// MuiModal 全体には掛けず、Dialog の「背景スクロール禁止」は従来どおり維持する。
export const appTheme = createTheme({
  components: {
    MuiMenu: {
      defaultProps: { disableScrollLock: true },
    },
    MuiPopover: {
      defaultProps: { disableScrollLock: true },
    },
  },
});
